import { MapPinOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t("errors.not_found_title")} />
      <EmptyState
        icon={MapPinOff}
        title={t("errors.not_found_body")}
        action={
          <Button asChild>
            <Link to="/">{t("errors.back_home")}</Link>
          </Button>
        }
      />
    </div>
  );
}
